enum UserTypes {
    USER_LOADED = 'USER_LOADED',
    USER_AUTHENTICATED = 'USER_AUTHENTICATED',
    USER_AUTHENTICATION_HAS_SET = 'USER_AUTHENTICATION_HAS_SET',
    AUTHENTICATING_USER = 'AUTHENTICATING_USER',
    AUTH_EXTERNAL_USER_REQUEST = 'AUTH_EXTERNAL_USER_REQUEST',
    USER_AUTH_ERROR = 'USER_AUTH_ERROR',
    USER_AVAILABLE = 'USER_AVAILABLE',
    USER_NOT_AVAILABLE = 'USER_NOT_AVAILABLE',
    GET_QUICK_CONNECTS = 'GET_QUICK_CONNECTS',
    AFTER_CALL_WORK = 'AFTER_CALL_WORK',
    AFTER_CALL_WORK_END = 'AFTER_CALL_WORK_END',
    SHOW_QUICK_CONNECTS = 'SHOW_QUICK_CONNECTS',
    HIDE_QUICK_CONNECTS = 'HIDE_QUICK_CONNECTS',
    TOGGLE_QUICK_CONNECTS = 'TOGGLE_QUICK_CONNECTS',
    USER_SET_STATE = 'USER_SET_STATE',
    CALL_ISSUE = 'CALL_ISSUE',
    USER_ERROR = 'USER_ERROR',
    REFRESH = 'REFRESH',
    FETCH_QUEUE_STATS = 'FETCH_QUEUE_STATS',
    FETCH_AGENT_STATS = 'FETCH_AGENT_STATS',
    LOGIN = 'LOGIN',
    LOGOUT = 'LOGOUT',
    VALIDATING_TOKEN = 'VALIDATING_TOKEN',
    REQUESTING_TOKEN = 'REQUESTING_TOKEN',
    INCORRECT_TOKEN = 'INCORRECT_TOKEN',
    TOKEN_REQUESTED = 'TOKEN_REQUESTED',
    TOKEN_ERROR = 'TOKEN_ERROR',
    NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED',
    NEW_PASSWORD_REQUIRED_CHANGE = 'NEW_PASSWORD_REQUIRED_CHANGE',
    FORGOT_PASSWORD = 'FORGOT_PASSWORD',
    REMEMBERED_PASSWORD = 'REMEMBERED_PASSWORD',
    FORGOT_PASSWORD_GET_CODE = 'FORGOT_PASSWORD_GET_CODE',
    FORGOT_PASSWORD_CONFIRM = 'FORGOT_PASSWORD_CONFIRM',
    MFA_REQUIRED = 'MFA_REQUIRED',
    SUBMIT_MFA = 'SUBMIT_MFA',
    SET_TIME_RANGE = 'SET_TIME_RANGE',
    SET_AFTER_CALL_STATUS = 'SET_AFTER_CALL_STATUS',
    SET_LOGOUT_COUNTDOWN = 'SET_LOGOUT_COUNTDOWN',
    SET_SHOW_NEXT_STATUS = 'SET_SHOW_NEXT_STATUS',
    SET_STATUS_CONTROL = 'SET_STATUS_CONTROL',
}

export default UserTypes;
